import BaseValidator from "./BaseValidator";

const phoneValidator = Object.create(BaseValidator);

// Very basic regex, heavy work done by backend
phoneValidator.validateAgainstRegex = /^\+\d{3,}.+$/;

export default phoneValidator.init();
